import PropTypes from 'prop-types';
import { css, cx, etiColors } from '@eti/styles';
import Radio from '../radio/Radio';
import Message from '../common/Message';
import RadioGroup from '../radio_group/RadioGroup';
import Icon from '../icon/Icon';
import { errorStyles, getSelectedStyles, getSizeStyles, isRequiredStyles, labelStyles, radioStyles, toggleBarStyles, toggleBarContainerStyles } from './toggleBarStyles';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const getClassName = (hasErrors, isReadOnly, isRequired, selectedValue, option, size) => cx('etiToggleBarButton', radioStyles(isReadOnly), isRequired && isRequiredStyles, hasErrors && errorStyles, selectedValue != null && getSelectedStyles(selectedValue === option.value, isReadOnly), selectedValue === option.value && 'selectedOption', getSizeStyles(size), option.className, hasErrors && 'error', isRequired && selectedValue == null && 'required');
const renderOptions = _ref => {
  let {
    isNeutral,
    isRequired,
    options,
    hasErrors,
    isReadOnly = false,
    selectedValue,
    size
  } = _ref;
  return options.map(option => /*#__PURE__*/_jsx(Radio, {
    className: getClassName(hasErrors, isReadOnly, isRequired, selectedValue, option, size),
    dataTestId: option.dataTestId,
    disabled: isReadOnly,
    id: option.id,
    isNeutral: isNeutral,
    value: option.value,
    children: option.label
  }, option.id));
};
const wrapperStyle = css`
  min-height: 1.125rem;
`;
const errorMessage = css`
  align-items: center;
  color: ${etiColors.critical.solid};
  display: flex;
  font-size: 0.875rem;
  margin-top: 0.375rem;
`;
const iconClassName = css`
  fill: ${etiColors.critical.solid};
  height: 15px;
  margin-left: 0.5rem;
  margin-top: 0.375rem;
  width: 15px;

  [dir='rtl'] & {
    margin-left: 0;
    margin-right: 0.5rem;
  }
`;
const ToggleBar = _ref2 => {
  let {
    className,
    dataTestId,
    error,
    hasErrors,
    isNeutral,
    isReadOnly,
    isRequired,
    label,
    inputName,
    onValueChange,
    onFocus,
    options,
    selectedValue,
    size,
    legend
  } = _ref2;
  return /*#__PURE__*/_jsxs("div", {
    className: cx('etiToggleBarContainer', toggleBarContainerStyles, className),
    "data-testid": dataTestId,
    children: [label && /*#__PURE__*/_jsx("span", {
      className: labelStyles,
      children: label
    }), /*#__PURE__*/_jsx(RadioGroup, {
      className: cx('etiToggleBar', toggleBarStyles),
      legend: legend,
      name: inputName,
      onChange: onValueChange,
      onFocus: onFocus,
      role: "group",
      selectedValue: selectedValue,
      children: renderOptions({
        isNeutral,
        isReadOnly,
        isRequired,
        options,
        hasErrors: hasErrors || error,
        selectedValue,
        size
      })
    }), error && /*#__PURE__*/_jsxs("div", {
      className: errorMessage,
      children: [/*#__PURE__*/_jsx(Icon, {
        className: iconClassName,
        id: "circle-error"
      }), /*#__PURE__*/_jsx("div", {
        className: wrapperStyle,
        children: /*#__PURE__*/_jsx(Message, {
          error: error
        })
      })]
    })]
  });
};
ToggleBar.propTypes = {
  className: PropTypes.string,
  dataTestId: PropTypes.string,
  error: PropTypes.string,
  hasErrors: PropTypes.bool,
  inputName: PropTypes.string.isRequired,
  isNeutral: PropTypes.bool,
  isReadOnly: PropTypes.bool,
  isRequired: PropTypes.bool,
  label: PropTypes.string,
  legend: PropTypes.string,
  onFocus: PropTypes.func,
  onValueChange: PropTypes.func,
  options: PropTypes.arrayOf(PropTypes.shape({
    className: PropTypes.string,
    id: PropTypes.string.isRequired,
    label: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool, PropTypes.arrayOf(PropTypes.shape({
      priceRaw: PropTypes.number,
      value: PropTypes.string
    }))])
  })).isRequired,
  selectedValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool, PropTypes.arrayOf(PropTypes.shape({
    priceRaw: PropTypes.number,
    value: PropTypes.string
  }))]),
  size: PropTypes.oneOf(['large', 'standard'])
};
export default ToggleBar;
//# sourceMappingURL=ToggleBar.js.map